<div
  [nxCopytext]="field.textSize ?? 'normal'"
  class="nx-margin-y-2s margin-box wrapper-text-box"
  [ngClass]="field.customClass"
  [innerHTML]="field.text | translate"
></div>
